import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

///IDIOMAS
import { lang_navigation } from 'app/idiomas/i18n/navigation/navigation.lang';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

//SERVICE
import { LandingCloudService } from "./landingCloud.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import * as $ from 'jquery';

@Component({
  selector: 'app-landingCloud',
  templateUrl: './landingCloud.component.html',
  styleUrls: ['./landingCloud.component.scss'],
  animations : fuseAnimations
})
export class LandingCloudComponent implements OnInit {
  origen: any;
  producto: any;
  private _unsubscribeAll: Subject<any>;
  productosAsignados: any[] = [
    { nombre: '1.0', version: 'legacy' },
    { nombre: '2.0', version: 'current' },
  ];
  cargando:boolean;
  titleProducto = "Gestor de archivos";
  datosProducto: any;

  constructor(
    private activatedRoute:ActivatedRoute,
    private http:HttpClient,
    private landingService : LandingCloudService,
    private router: Router,
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private location: Location
  ) {
    this._unsubscribeAll = new Subject();
    lang_navigation.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(params => {
      console.log(params);
        this.origen = params;
    });
    this.activatedRoute.params.subscribe(params => {
      console.log("params data",params);
      this.datosProducto = params;
    });
  }
  navigateTo(producto){
    let ruta = this.origen.producto == 'cloudODS' ? 'file-server-private' : 'file-server';
    if (Object.keys(this.datosProducto).length>0) {
      this.router.navigate([ruta, producto.version, this.datosProducto.id, this.datosProducto.idprod]);
    }else{
      this.router.navigate([ruta, producto.version]);
    }
  }

  regresarDetail(){
    // this.router.navigate(['/companies/detail',this.idEmpresa]);
    this.location.back();
  }

}
